import { ROLE_VALUES } from "./roles";

export const PERMISSIONS = {
  [ROLE_VALUES.FOUNDER]: {
    createUser: true,
    manageProjects: true,
    deleteProject: true,
    approveRequests: true,
    viewFinance: true,
    reviewTasks: true,
  },

  [ROLE_VALUES.TEAM_LEADER]: {
    createUser: true,
    manageProjects: true,
    deleteProject: true,
    approveRequests: true,
    viewFinance: false,
    reviewTasks: true,
  },

  [ROLE_VALUES.LEADER]: {
    createUser: true,
    manageProjects: true,
    deleteProject: true,
    approveRequests: true,
    viewFinance: false,
    reviewTasks: true,
  },

  [ROLE_VALUES.MANAGER]: {
    createUser: true,
    manageProjects: true,
    deleteProject: true,
    approveRequests: true,
    viewFinance: false,
    reviewTasks: true,
  },

  [ROLE_VALUES.EMPLOYEE]: {
    createUser: false,
    manageProjects: false,
    deleteProject: false,
    approveRequests: false,
    viewFinance: false,
    reviewTasks: false,
  },
};